import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import config from "../common/Config";
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import * as XLSX from 'xlsx';

const EposSales = () => {

	const eposSaleTableRef = useRef(null);
	const [searchValue, setSearchValue] = useState([]);
	const [dates, setDates] = useState([null, null]);
	const [reportrange, setReportrange] = useState('');

	const accessToken = localStorage.getItem('accessToken');

	const handleDateChange = (value) => {
		setDates(value);
		let startDate = value[0] ? format(value[0], 'MM/dd/yyyy') : '';
		let endDate = value[1] ? format(value[1], 'MM/dd/yyyy') : '';
		setReportrange(startDate ? startDate + ' - ' + endDate : '');
	};

	const fetchEposSalesTable = () => {
		const $table = $(eposSaleTableRef.current);
		const searchValue = $('#searchValue').val();
		if ($.fn.DataTable.isDataTable($table)) {
			$table.DataTable().destroy();
		}

		let i = 0;
		$table.DataTable({
			processing: true,
			serverSide: true,
			ajax: {
				url: `${config.API_URL}/sales/pos_paid_list`,
				type: 'POST',
				headers: {
					authorization: `Bearer ${accessToken}`,
				},
				data: function (d) {
					return $.extend({}, d, {
						draw: d.draw,
						start: d.start,
						length: d.length,
						searchValue: searchValue,
						sale_status: 'Delivered',
						reportrange: reportrange // <-- Pass date range to API
					});
				},
				dataSrc: function (json) {
					if (json && json.data && Array.isArray(json.data)) {
											// Update the footer with totals from the API response
						$('#grandTotal').html(parseFloat(json.grand_total.replace(/,/g, '')).toFixed(2));
						$('#paid').html(parseFloat(json.paid.replace(/,/g, '')).toFixed(2));
						$('#cashAmount').html(parseFloat(json.cash_amount.replace(/,/g, '')).toFixed(2));
						$('#chequeAmount').html(parseFloat(json.cheque_amount.replace(/,/g, '')).toFixed(2));
						$('#cardAmount').html(parseFloat(json.card_amount.replace(/,/g, '')).toFixed(2));
						$('#creditcardAmount').html(parseFloat(json.credit_card_amount.replace(/,/g, '')).toFixed(2));
					}
					
					return Array.isArray(json.data) ? json.data : [];
					console.log(json);
				}
				
			},
			language: {
				paginate: {
					first: 'First',
					last: 'Last',
					next: 'Next',
					previous: 'Previous',
				},
				search: 'Search:',
			},
			columns: [

				{
					data: null,
					width: '8%',
					render: function (data, type, row) {
						return `<span>${row.date}</span>`
					}
				},
				{
					data: null,
					width: '10%',
					render: function (data, type, row) {

						return '<a href="' + config.BASE_URL + '/order_summary/print/' + row.ids + '">' + row.reference_no + '</a>';
					}
				},
				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span>${row.customer}</span>`
					}
				},
				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span  class="text-right">${row.grand_total}</span>`
					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},
				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span>${row.paid}</span>`

					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},
				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span  class="text-right">${row.cash_amount}</span>`
					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},
				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span  class="text-right">${row.cheque_amount}</span>`
					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span  class="text-right">${row.card_amount}</span>`
					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span  class="text-right">${row.credit_card_amount}</span>`
					}
					,
					createdCell: function (td) {
						$(td).css("text-align", "right");
					}
				},
			// 	{
			// data: null,  // No direct data field for this column
			// width: '12%',
			// render: function (data, type, row) {
			// 	// Check the value of 'sale_status' and render accordingly
			// 	if (row.sale_status === 'Delivered') {
			// 	return `<span class="status-delivered">Completed</span>`;  // Correct class name if needed
			// 	} else {
			// 	// Default case for handling other statuses
			// 	return `<span class="status-other">${row.sale_status}</span>`;
			// 	}
			// }
			// },


				{
					data: null,
					width: '12%',
					render: function (data, type, row) {
						return `<span>${row.payment_status}</span>`
					}
				},

			],
			columnDefs: [
				{
					orderable: false,
					targets: '_all'
				},
			],

			pageLength: 50,
		});


	};

	useEffect(() => {

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}
		fetchEposSalesTable();
		return () => {
			if (eposSaleTableRef.current && $.fn.DataTable.isDataTable(eposSaleTableRef.current)) {
				$(eposSaleTableRef.current).DataTable().destroy();
			}
		};
	// Add reportrange as dependency to reload table on date change
	}, [searchValue, reportrange]);

	return (
		<div>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<a href="#"><i className="fa fa-home"></i></a> &gt; <a href="Dashboard">Epos</a> &gt; <span className="last-crumb">Completed POS Sales</span>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<div className="show-order-area dashboard" style={{ position: 'relative' }}>
								<div className="row">
									<div className="date-range-picker col-md-4 col-lg-4 col-sm-12" style={{ float: 'left' }}>
										<div className="row mb-3 padd-0">
											<label className="col-sm-4" style={{ marginBottom: '5px' }} ><b>Select Date</b></label>
											<div className="col-sm-8">
												<DateRangePicker
													value={dates}
													placeholder="DD/MM/YYYY - DD/MM/YYYY"
													onChange={handleDateChange}
													format="dd/MM/yyyy"
													character=" - "
													style={{ width: '100%' }}
												/>
											</div>
										</div>
									</div>
									<div className="col-md-2 col-lg-2 col-sm-6" style={{ float: 'left' }} >
										<button
											type="button"
											onClick={fetchEposSalesTable}
											className="acceptbtn"
											style={{ float: 'left' }}
										>
											Submit
										</button>
										<button
												 className="create-catalogue-btn"  style={{ textTransform: 'capitalize' }}
												onClick={() => {
													// Get table data from DataTable instance
													if (eposSaleTableRef.current && $.fn.DataTable.isDataTable(eposSaleTableRef.current)) {
														const dt = $(eposSaleTableRef.current).DataTable();
														const data = dt.rows({ search: 'applied' }).data().toArray();
														const headers = [
															'Date', 'Invoice No', 'Customer', 'Grand Total', 'Paid',
															'Cash Amt', 'Cheque Amt', 'Card Amt', 'Credit Facility', 'Status', 'Payment Status'
														];
														const rows = data.map(row => [
															row.date,
															row.reference_no,
															row.customer,
															row.grand_total,
															row.paid,
															row.cash_amount,
															row.cheque_amount,
															row.card_amount,
															row.credit_card_amount,
															row.sale_status === 'Delivered' ? 'Completed' : row.sale_status,
															row.payment_status
														]);
														const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
														const wb = XLSX.utils.book_new();
														XLSX.utils.book_append_sheet(wb, ws, "EPOS Sales");
														XLSX.writeFile(wb, "epos_sales.xlsx");
													}
												}}
											>
												Export to Excel
											</button>
									</div>
									

								</div>
								<div>
									<div className="verical-scrl-wrapper common-table epos-sales-area-list" id="style-3">
										<div style={{ marginBottom: '10px' }}>
											
											
										</div>
										<table className="table table-bordered dataTable resizable" id="neworderTable" ref={eposSaleTableRef}>
											<thead>
												<tr>
													<th>Date</th>
													<th>Invoice No</th>
													<th>Customer</th>
													<th>Grand Total</th>
													<th>Paid</th>
													<th>Cash Amt</th>
													<th>Cheque Amt</th>
													<th>Card Amt</th>
													<th>Credit Facility</th>
													{/* <th>Status</th> */}
													<th>Payment Status</th>
												</tr>
											</thead>
											<tbody>

											</tbody>
											 <tfoot>
												<tr>
													<th colSpan="3" style={{ textAlign: 'right' }}>Total</th>
													<th id="grandTotal" style={{ textAlign: 'right' }}></th>
													<th id="paid" style={{ textAlign: 'right' }}></th>
													<th id="cashAmount"></th>
													<th id="chequeAmount"></th>
													<th id="cardAmount"></th>
													<th id="creditcardAmount"></th>
													<th ></th>
												</tr>
											</tfoot>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />

		</div>
	);

}
export default EposSales;